<template>
  <div class="agreement-download-container">
    <div class="card">
      <div v-if="loading" class="loading-state">
        <i class="el-icon-loading loading-icon"></i>
        <h2>Preparing your download...</h2>
        <p>Please wait while we retrieve your agreement document.</p>
      </div>
      <div v-else-if="error" class="error-state">
        <i class="el-icon-error error-icon"></i>
        <h2>Download Failed</h2>
        <p>{{ error }}</p>
        <button class="btn-retry" @click="downloadAgreement">Try Again</button>
      </div>
      <div v-else class="success-state">
        <i class="el-icon-success success-icon"></i>
        <h2>Download Complete</h2>
        <p>Your agreement document has been downloaded.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AgreementDownload',
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  mounted() {
    this.downloadAgreement();
  },
  methods: {
    async downloadAgreement() {
      this.loading = true;
      this.error = null;
      const agreementId = this.$route.params.id;

      try {
        axios.defaults.headers.common['Authorization'] =
          'Bearer ' + this.$store.state.token;

        const response = await axios.get(
          `/general/agreement-download/${agreementId}`,
          { responseType: 'blob' }
        );

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', 'agreement.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        this.loading = false;
      } catch (err) {
        this.loading = false;
        if (err.response && err.response.status === 403) {
          this.error = 'You do not have permission to download this document.';
        } else if (err.response && err.response.status === 404) {
          this.error = 'Document not found.';
        } else {
          this.error = 'An error occurred while downloading the document. Please try again.';
        }
      }
    },
  },
};
</script>

<style scoped>
.agreement-download-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}
.card {
  text-align: center;
  padding: 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  width: 100%;
}
.loading-icon {
  font-size: 48px;
  color: #3498db;
  margin-bottom: 16px;
}
.error-icon {
  font-size: 48px;
  color: #e74c3c;
  margin-bottom: 16px;
}
.success-icon {
  font-size: 48px;
  color: #2ecc71;
  margin-bottom: 16px;
}
h2 {
  font-size: 22px;
  margin-bottom: 8px;
}
p {
  color: #666;
  margin-top: 0;
}
.btn-retry {
  margin-top: 16px;
  padding: 10px 24px;
  font-size: 14px;
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.btn-retry:hover {
  background-color: #2980b9;
}
</style>
